var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Polygon_3","data-name":"Polygon 3","d":"M5.293.707a1,1,0,0,1,1.414,0l3.586,3.586A1,1,0,0,1,9.586,6H2.414a1,1,0,0,1-.707-1.707Z","transform":"translate(12 6) rotate(180)"}));
}

Chevron.defaultProps = {"width":"12","height":"6","viewBox":"0 0 12 6"};

module.exports = Chevron;

Chevron.default = Chevron;
